// extracted by mini-css-extract-plugin
export var modal = "_mi-0";